import { Outlet, useNavigate } from 'react-router-dom'
import Narbar from './Navbar'
import Sidebar from './SideBar'
import useAuthContext from 'hooks/useAuthContext'
import { useEffect } from 'react'
import { ADMIN_URLS } from 'constans/urls'

const Layout = () => {
  const { isAuthenticated } = useAuthContext()
  const navigate = useNavigate()

  useEffect(() => {
    if (!isAuthenticated) {
      navigate(ADMIN_URLS.LOGIN)
    }
  }, [navigate, isAuthenticated])
  return (
    <main className="main" id="top">
      <Sidebar />
      <Narbar />
      <Outlet />
    </main>
  )
}

export default Layout
